<template>
    <div class="page fill-height">
        <v-container :class="{'d-flex pb-lg-16 px-6 px-lg-7 flex-column align-center mt-12 mt-lg-0 justify-lg-center fill-height': !isAuthed}">
            <div v-if="!isAuthed" class="d-flex justify-center mb-9">
                <logo height="90" />
            </div>

            <v-card class="bordered rounded" :class="{'w-100': phoneOnly}">
                <div class="form-wrapper" :class="{'w-full': isAuthed}">
                    <v-card-title class="font-weight-semibold pt-2 mb-5">
                        <div v-if="!isAuthed">
                            <v-btn icon class="me-1" :to="{name: 'login'}"><v-icon>mdi-arrow-left</v-icon></v-btn>
                        </div>
                        How can we help you?
                    </v-card-title>
                    <v-card-text>
                        <form @submit.prevent="submitAction">
                            <!-- <v-text-field hide-details class="mb-4" placeholder="Enter Message Subject" label="Subject" name="title" v-model="title" :loading="loading" :disabled="loading" outlined></v-text-field> -->
                            <v-textarea hide-details class="mb-5" rows="5" no-resize auto-grow placeholder="Enter Message Details" label="Message" name="content" v-model="content" :loading="loading" :disabled="loading" filled />
                            <v-btn type="submit" :block="phoneOnly" min-width="170px" depressed large :disabled="loading" color="primary" @click.prevent="submitAction">
                                <v-icon left>mdi-send</v-icon>
                                <span>Send</span>
                            </v-btn>
                        </form>

                        <template v-if="platform === 'ios' && isAuthed">
                            <v-divider class="my-5"></v-divider>
                            <div>
                                <h3 class="font-weight-bold strong-text--text d-flex justify-center align-center mb-2 mb-lg-3">
                                    <span>Account Deletion</span>
                                </h3>
                                <p class="text-center details-text muted--text">Account deletion requests are processed within 24 to 48 hours.</p>
                          
                                <v-btn outlined :disabled="sentTicket || loading" block class="mb-4" @click="deleteAccountDialog = true">
                                    <v-icon>mdi-delete</v-icon>
                                    <span>Delete Account</span>
                                </v-btn>
                            </div>

                        </template>

                        <div v-if="appData.whatsapp_url">
                            <v-divider class="my-6"></v-divider>
                            <div class="mb-2" style="font-size: 16px;">
                                Or contact us via:
                            </div>
                            <v-btn as="a" dark target="_blank" :large="pcOnly" :href="appData.whatsapp_url" depressed color="green">
                                <v-icon size="20" left>mdi-whatsapp</v-icon>
                                <span>Whatsapp</span>
                            </v-btn>
                        </div>
                    </v-card-text>
                </div>
            </v-card>

            <v-dialog transition="slide-y-transition" v-model="deleteAccountDialog" scrollable max-width="350" overlay-color="#000" overlay-opacity="0.75">
                <v-card>
                    <v-card-title class="mb-2">Delete Account</v-card-title>
                    <v-card-subtitle>Are you sure you want to delete your account?</v-card-subtitle>
              
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="muted" @click="deleteAccountDialog = false" :disabled="loading">cancel</v-btn>
                        <v-btn text color="error" :disabled="loading" :loading="loading" @click="deleteAccountAction"><strong>Delete</strong></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>

        <slot name="footer" />
    </div>
</template>

<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'Help',
    data(){
        return {
            content: '',
            loading: false,

            sentTicket: null,

            deleteAccountDialog: false,
        };
    },
    components: {
        
    },
    computed:{
        ...GlobalComputed 
    },
    methods: {
        ...GlobalMethods,
        deleteAccountAction(){
            this.content = 'Account Deletion Request';
            this.submitAction();
        },
        validateEmail(email) {
            const regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regEx.test(email);
        },

        validate(){
            if (this.content.trim()){
                if (this.isAuthed){
                    return {
                        content: this.content,
                    }
                }
                return {
                    content: this.content,
                }
            }else{
                return false;
            }
        },
        reset(){
            this.content = '';
        },
        submitAction(){
            if (!this.loading){
                this.sentTicket = null;
                let data = this.validate();
                if (data){
                    if (this.isAuthed){
                        this.loading = true;
    
                        this.$store.dispatch('fastPostAction', {url: `/support-tickets`, data}).then((response)=>{
                            let id = response.data.data.id;
                            this.showMsg('We\'ve received your message, We will get back to you ASAP.', 'success');
                            this.loading = false;
                            this.sentTicket = id;
                            this.reset();
                            window.setTimeout(()=>{
                                this.$router.push({name: 'inbox'});
                            }, 500);
                            
                        }).catch(()=>{
                            this.showMsg('Error occurred during sending your request', 'error');
                            this.loading = false;
                        })                    
                    }else{
                        this.showMsg('Email is not valid', 'error');
                    }
                }else{
                    this.showMsg('Inputs are required');
                }
            }
        },
    },
    watch: {
        
    },
    mounted(){
        

    }
}
</script>

<style lang="scss" scoped>

</style>